import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  comment_id: string().required(),
});

/**
 * CardCommentCreateEvent
 *
 * - Evento emitido quando um comentário de card é criado.
 */
export class CardCommentCreateEvent extends CreateCommand(RealtimeEventType.CardCommentCreate, SCHEMA) {}
